export default __webpack_public_path__ + "static/media/new_logo.19793f95.png";